import React from 'react';
import '../styles/ActivityCard.css';

const ActivityCard = ({ title, description, image }) => {
  return (
    <div className="activity-card">
      <div className="activity-card-inner">
        <div className="activity-card-front">
          <img src={image} alt={title} />
        </div>
        <div className="activity-card-back">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;